import React from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

import View from './views';
import API from '../../requests';
import FireboardUtils from '../../util/fireboard-util';
import { getPopupConfig } from '../../components/Popup';
import tableMergeEnum from '../../enums/tableMergeEnum';

class EmployeeAssignment extends React.Component {

  state = {
    popup: undefined,
    stations: [],
    employees: [],
    station: undefined,
    employee: undefined,
    stationEmployees: new Map(),
    employeeStations: new Map(),
    stationView: false,
    excludeTerminated: true,
    tableWithSensors: true,
    jobAllowsAssignment: true,
    jobsMap: new Map(),
    assigned: false,
    sortByName: true,
    filteredEmployees: [],
    searchEmployeeValue: '',
    revenueCentersMap: new Map(),
    // jobTypes: [],
    // selectedJobTypeId: -1,
  };
  sensorsObject = {};

  componentDidMount() {
    this.getSensorsFromStoreInfo();
    this.getStationEmployees();
  }

  getStationEmployees = () => {
    const { reduxProps: { storeInfo } } = this.props;
    const { id: storeId, jobs = [], revenueCenters } = storeInfo?.data || {};
    let jobsMap = new Map();
    jobs.forEach(job => jobsMap.set(job.id, job));
    let revenueCentersMap = new Map();
    revenueCenters.forEach(revenueCenter => revenueCentersMap.set(revenueCenter.id, revenueCenter.name));

    /* let { jobTypes = [] } = storeInfo?.data || {};
    const allJobType = {
      externalId: '',
      id: -1,
      name: 'All',
      shortName: null,
    };
    jobTypes = [allJobType, ...jobTypes]; */
    this.getPopup('spinner', 'Fetching employee assignments', null);
    API.getStationEmployees({ storeId })
      .then(response => {
        const stations = response.data.stationEmployees;
        const employees = response.data.employeeStations;
        stations.sort(this.sortByStation);
        this.setState({
          stations,
          employees,
          filteredEmployees: employees,
          popup: undefined,
          jobsMap,
          revenueCentersMap,
          // jobTypes,
        });
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => {
        this.getErrorPopup(error);
      });
  };

  getSensorsFromStoreInfo = () => {
    const { reduxProps: { storeInfo } } = this.props;
    const { sensors } = storeInfo?.data || {};
    let sensorsObject = {};
    sensors.forEach(sensor => {
      if (sensor.stationId && !sensorsObject.hasOwnProperty([sensor.stationId]))
        sensorsObject[sensor.stationId] = true;
    });
    this.sensorsObject = sensorsObject;
  };

  pad = (value) => {
    let str = String(value);
    let size = 10;
    while (size > 0) {
      str = '0' + str;
      size--;
    }
    return str;
  };

  sortByStation = (a, b) => {
    const name1 = FireboardUtils.addPrefixWithZero(a.station.name ? a.station.name : '', 10).toLowerCase();
    const name2 = FireboardUtils.addPrefixWithZero(b.station.name ? b.station.name : '', 10).toLowerCase();
    if (name1 < name2) {
      return -1;
    }
    if (name1 > name2) {
      return 1;
    }
    return 0;
  };

  sortByEmployeeLastName = (a, b) => {
    const name1 = this.pad(a.employee.lastName ? a.employee.lastName : '').toLowerCase();
    const name2 = this.pad(b.employee.lastName ? b.employee.lastName : '').toLowerCase();
    if (name1 < name2) {
      return -1;
    }
    if (name1 > name2) {
      return 1;
    }
    return 0;
  };

  sortByEmployeePOSID = (a, b) => {
    const posId1 = FireboardUtils.addPrefixWithZero(a.employee.posId ? a.employee.posId : '', 10).toLowerCase();
    const posId2 = FireboardUtils.addPrefixWithZero(b.employee.posId ? b.employee.posId : '', 10).toLowerCase();
    if (posId1 < posId2) {
      return -1;
    }
    if (posId1 > posId2) {
      return 1;
    }
    return 0;
  };

  setStationOrEmployee = (stationParam, employeeParam, actionType, source, parentTable) => {
    const { stationView } = this.state;
    if (stationView) {
      switch (actionType) {
        case tableMergeEnum.ASSIGN:
          if (source === tableMergeEnum.EMPLOYEE) break;
          const { station, stationEmployees } = this.state;
          stationEmployees.clear();
          if (station && station?.station?.id === stationParam?.station?.id) {
            this.setState({ station: undefined, stationEmployees });
          } else {
            this.setState({ station: stationParam, stationEmployees });
          }
          break;
        case tableMergeEnum.REMOVE:
          this.onRemove(stationParam.station, employeeParam, source);
          break;
        default:
          console.warn('case not handled...');
          break;
      }
    } else {
      switch (actionType) {
        case tableMergeEnum.ASSIGN:
          if (source === tableMergeEnum.STATION) break;
          const { employee, employeeStations } = this.state;
          employeeStations.clear();
          if (employee && employee?.employee?.id === employeeParam?.employee?.id) {
            this.setState({ employee: undefined, employeeStations });
          } else {
            this.setState({ employee: employeeParam, employeeStations });
          }
          break;
        case tableMergeEnum.REMOVE:
          this.onRemove(stationParam, employeeParam.employee, source);
          break;
        default:
          console.warn('case not handled...');
          break;
      }
    }
  };

  setEmployeeAssignment = employee => {
    let { stationEmployees } = this.state;
    if (stationEmployees.has(employee.id)) {
      stationEmployees.delete(employee.id);
    } else {
      stationEmployees = new Map();
      stationEmployees.set(employee.id, employee);
    }
    this.setState({ stationEmployees });
  };

  setTableAssignment = table => {
    const { employeeStations } = this.state;
    if (employeeStations.has(table.id)) {
      employeeStations.delete(table.id);
    } else {
      employeeStations.set(table.id, table);
    }
    this.setState({ employeeStations });
  }

  assignEmployee = () => {
    const { station, stationEmployees } = this.state;
    const employeeIds = Array.from(stationEmployees.keys()) || [];
    const callback = () => {
      const { reduxProps: { storeInfo } } = this.props;
      const { id: storeId } = storeInfo?.data || {};
      if (station && station?.station && station?.station?.id && employeeIds.length > 0) {
        const payload = {
          storeId,
          stationId: station.station.id,
          employeeId: employeeIds[0],
        }
        this.getPopup('spinner', 'Assigning employee', null);
        API.assignEmployee(payload)
          .then(response => {
            this.resetStations(response.data);
            toast.success("Employee assigned successfully", { autoClose: 1000 });
          })
          .catch(error => {
            this.getErrorPopup(error);
          });
      }
    };

    const message = `This will assign employee ${stationEmployees.get(employeeIds[0]).firstName} to table ${station?.station.name}. Would you like to continue?`;
    return { callback, message };
  }

  assignTable = () => {
    const { employee, employeeStations } = this.state;
    let mergedStationIds = [];
    let mergedStationNames = [];
    employeeStations.forEach((value, key) => {
      mergedStationIds.push(key);
      mergedStationNames.push(value.name);
    });
    const callback = () => {
      const { reduxProps: { storeInfo } } = this.props;
      const { id: storeId } = storeInfo?.data || {};
      if (employee && employee?.employee && employee?.employee?.id && mergedStationIds.length > 0) {
        const payload = {
          storeId,
          employeeId: employee.employee.id,
          stationIds: [...mergedStationIds]
        }
        this.getPopup('spinner', 'Assigning tables', null);
        API.assignTable(payload)
          .then(response => {
            this.resetStations(response.data);
            toast.success("Table assigned successfully", { autoClose: 1000 });
          })
          .catch(error => {
            this.getErrorPopup(error);
          });
      }
    };

    const message = `This will merge table ${mergedStationNames} to employee ${employee.employee.firstName}. Would you like to continue?`;
    return { callback, message };
  }

  onMerge = () => {
    const { stationView } = this.state;
    let msg = '';
    let callbackInvoked = {};
    if (stationView) {
      const { message, callback } = this.assignEmployee();
      msg = message;
      callbackInvoked = callback;
    } else {
      const { message, callback } = this.assignTable();
      msg = message;
      callbackInvoked = callback;
    }
    !!callbackInvoked && callbackInvoked();
  };

  removeTableAssignment = (employee, station, source) => {
    const callback = () => {
      const { reduxProps: { storeInfo } } = this.props;
      const { id: storeId } = storeInfo?.data || {};
      const payload = {
        storeId,
        employeeId: employee.id,
        stationIds: source === tableMergeEnum.EMPLOYEE ? [] : [station.id],
      };
      this.getPopup('spinner', 'Removing table assignment', null);
      API.removeTableAssignment(payload)
        .then(response => {
          this.resetStations(response.data);
          toast.success("Table assignment removed successfully", { autoClose: 1000 });
        })
        .catch(error => {
          this.getErrorPopup(error);
        });
    };

    const message = source === tableMergeEnum.EMPLOYEE
      ? `All the tables assigned to the employee ${employee.firstName} will be removed. Would you like to continue?`
      : `This will remove table assignment ${station.name} from employee ${employee.firstName}. Would you like to continue?`;
    return {
      callback,
      message
    }
  }

  removeEmployeeAssignment = (employee, station) => {
    const callback = () => {
      const { reduxProps: { storeInfo } } = this.props;
      const { id: storeId } = storeInfo?.data || {};
      const payload = {
        storeId,
        employeeId: employee.id,
        stationId: station.id,
      };
      this.getPopup('spinner', 'Removing employee assignment', null);
      API.removeEmployeeAssignment(payload)
        .then(response => {
          this.resetStations(response.data);
          toast.success("Employee assignment removed successfully", { autoClose: 1000 });
        })
        .catch(error => {
          this.getErrorPopup(error);
        });
    };

    const message = `This will remove employee assignment ${employee.firstName} from table ${station.name}. Would you like to continue?`;
    return {
      callback,
      message
    }
  }

  onRemove = (station, employee, source) => {
    const { stationView } = this.state;
    let msg = '';
    let callbackInvoked = {};
    if (stationView) {
      const { message, callback } = this.removeEmployeeAssignment(employee, station);
      msg = message;
      callbackInvoked = callback;
    } else {
      const { message, callback } = this.removeTableAssignment(employee, station, source);
      msg = message;
      callbackInvoked = callback;
    }
    !!callbackInvoked && callbackInvoked();
  };

  resetStations = response => {
    const { stationEmployees, employeeStations } = this.state;
    const stations = response.stationEmployees;
    const employees = response.employeeStations;
    stationEmployees.clear();
    employeeStations.clear();
    stations.sort(this.sortByStation);
    this.setState({
      stations,
      employees,
      filteredEmployees: employees,
      popup: undefined,
      station: undefined,
      employee: undefined,
      stationEmployees,
      employeeStations,
      searchEmployeeValue: '',
    });
  }

  getPopup = (type, heading, message, callback) => {
    const popup =
      type === 'spinner'
        ? getPopupConfig('spinner')
        : getPopupConfig('error', () => {
          callback && callback();
          this.setState({ popup: undefined });
        });
    if (heading) {
      popup.heading = heading;
    }
    if (message) {
      popup.message = message;
    }
    this.setState({ popup });
  };

  closePopup = () => {
    this.setState({ popup: undefined });
  };

  getErrorPopup = (error) => {
    const errorMsg = error.response
      ? error.response.data
      : error.message;
    FireboardUtils.addNetworkLogs(error.response);
    this.getPopup('error', null, errorMsg);
  };

  goBack = () => {
    const { history } = this.props;
    history && history.goBack();
  };

  changeView = () => {
    this.setState(prevState => ({
      stationView: !prevState.stationView
    }));
  };

  toggleCheckbox = key => event => {
    this.setState({ [key]: event.target.checked });
  };

  onChangeSortByName = () => {
    this.setState(prevState => ({
      sortByName: !prevState.sortByName
    }));
  };

  onSearchEmployee = event => {
    const val = event.target.value;
    const value = val.toLowerCase();
    const { employees } = this.state;
    const filteredEmployees = employees && employees.filter(eachEmp => {
      const { employee } = eachEmp;
      const firstName = employee?.firstName || '';
      const lastName = employee?.lastName || '';
      const posId = employee?.posId || '';
      if ((firstName && firstName.toLowerCase().includes(value)) ||
        (lastName && lastName.toLowerCase().includes(value)) ||
        (posId && posId.toLowerCase().includes(value))
      ) {
        return eachEmp;
      }
    });
    this.setState({
      searchEmployeeValue: val,
      filteredEmployees,
    });
  };

  // onChangeJobType = e => {
  //   this.setState({ selectedJobTypeId: e.target.value });
  // };

  get viewProps() {
    const {
      popup,
      stations,
      station,
      filteredEmployees,
      employee,
      employeeStations,
      stationEmployees,
      stationView,
      excludeTerminated,
      // selectedJobTypeId,
      // jobTypes,
      tableWithSensors,
      jobAllowsAssignment,
      jobsMap,
      assigned,
      sortByName,
      searchEmployeeValue,
      revenueCentersMap,
    } = this.state || {};
    const employees = sortByName ? filteredEmployees.sort(this.sortByEmployeeLastName) : filteredEmployees.sort(this.sortByEmployeePOSID);

    return {
      popup,
      stations,
      station,
      employee,
      employees,
      employeeStations,
      stationEmployees,
      stationView,
      goBack: this.goBack,
      closePopup: this.closePopup,
      onMerge: this.onMerge,
      setStationOrEmployee: this.setStationOrEmployee,
      setEmployeeAssignment: this.setEmployeeAssignment,
      setTableAssignment: this.setTableAssignment,
      toggleCheckbox: this.toggleCheckbox,
      changeView: this.changeView,
      excludeTerminated,
      // jobTypes,
      // selectedJobTypeId,
      // onChangeJobType: this.onChangeJobType,
      tableWithSensors,
      jobAllowsAssignment,
      sensorsObject: this.sensorsObject,
      jobsMap: jobsMap,
      assigned,
      sortByName,
      onChangeSortByName: this.onChangeSortByName,
      searchEmployeeValue,
      onSearchEmployee: this.onSearchEmployee,
      revenueCentersMap,
    };
  };

  render() {
    const viewProps = this.viewProps;
    return <View {...viewProps} />;
  }
}

const mapStateToProps = (reduxProps) => ({
  reduxProps,
});

export default connect(mapStateToProps, null)(EmployeeAssignment);
